function formatDateToDDMMYYYY(date) {
    const day = String(date.getDate()).padStart(2, '0');    // Get day and pad with leading zero if needed
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Get month (0-indexed) and pad
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
}

export default async function exportToHTML(modalId) {
    // Get the main content you want to export
    const contentElement = document.getElementById(modalId + "_content");
    console.log(modalId);
    // Convert charts to images and replace canvases with images
    const canvases = contentElement.querySelectorAll('canvas');
    for (let canvas of canvases) {
        const dataURL = canvas.toDataURL('image/png');
        const img = document.createElement('img');
        img.src = dataURL;
        img.alt = 'Chart Image';

        // Copy width, height, and styles from the canvas
        img.width = canvas.width;
        img.height = canvas.height;

        // Copy all computed styles from the canvas to the image
        const canvasStyles = window.getComputedStyle(canvas);
        for (let style of canvasStyles) {
            img.style[style] = canvasStyles.getPropertyValue(style);
        }

        // Replace the canvas with the image in the DOM
        canvas.parentNode.replaceChild(img, canvas);
    }

    // Now that canvases are replaced, get the updated innerHTML
    const content = contentElement.innerHTML;

    // Collect all styles from <style> and <link rel="stylesheet"> tags
    const styles = Array.from(document.querySelectorAll('style, link[rel="stylesheet"]'))
        .map(style => {
            if (style.tagName === 'STYLE') {
                return `<style>${style.innerHTML}</style>`;
            } else if (style.tagName === 'LINK') {
                return `<link rel="stylesheet" href="${style.href}"/>`;
            }
            return '';
        })
        .join('\n');

    // Fetch the bundle.js file and encode it as Base64
    // const bundleBase64 = await fetchBundleAsBase64('/static/js/bundle.js'); // Fetch and encode bundle

    // Construct the full HTML document with converted images
    const today = new Date();

    const fullHTML = `
    <!DOCTYPE html>
    <html lang="en">
    <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>${modalId + " " + ' Data'  + formatDateToDDMMYYYY(today) }</title>
        ${styles}
    </head>
    <body>
        ${content}
    </body>
    </html>`;

    // Create a blob with the full HTML content
    const blob = new Blob([fullHTML], { type: 'text/html' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    // console.log(formatDateToDDMMYYYY(today));
    link.href = url;
    link.download = modalId      + "_" + 'Data' + "_" + formatDateToDDMMYYYY(today) + '.html';
    link.click();
    URL.revokeObjectURL(url);
}